import { getSelfEvaluation as getSelfEvaluationApi, getOtherEvaluation as getOtherEvaluationApi, getEvaluationDiff as getEvaluationDiffApi } from "../../service/EvaluationConfirmService";
export const GET_SELF_EVALUATION_SUCCESS = "GET_SELF_EVALUATION_SUCCESS";
export const GET_SELF_EVALUATION_FAIL = "GET_SELF_EVALUATION_FAIL";
export const GET_OTHER_EVALUATION_SUCCESS = "GET_OTHER_EVALUATION_SUCCESS";
export const GET_OTHER_EVALUATION_FAIL = "GET_OTHER_EVALUATION_FAIL";
export const GET_EVALUATION_DIFF_SUCCESS = "GET_EVALUATION_DIFF_SUCCESS";
export const GET_EVALUATION_DIFF_FAIL = "GET_EVALUATION_DIFF_FAIL";

export const getSelfEvaluation = request => dispatch => {
  getSelfEvaluationApi(request)
  .then(response => {
    if (response.message) {
      dispatch({ type: GET_SELF_EVALUATION_FAIL, payload: { message: response.message, code: response.messageCode } });
    }
    dispatch({
      type: GET_SELF_EVALUATION_SUCCESS, 
      payload: { 
        selfEvaluationList: response.selfEvaluationList,
        gradeRange: response.gradeRange
      }
    });
  })
  .catch(error => {
    dispatch({ type: GET_SELF_EVALUATION_FAIL, payload: { error: error } });
  });
}

export const getOtherEvaluation = request => dispatch => {
  getOtherEvaluationApi(request)
  .then(response => {
    if (response.message) {
      dispatch({ type: GET_OTHER_EVALUATION_FAIL, payload: { message: response.message, code: response.messageCode } });
    }
    dispatch({
      type: GET_OTHER_EVALUATION_SUCCESS, 
      payload: { 
        otherEvaluationList: response.otherEvaluationList, 
        gradeRange: response.gradeRange
      }
    });
  })
  .catch(error => {
    dispatch({ type: GET_OTHER_EVALUATION_FAIL, payload: { error: error } });
  });
}

export const getEvaluationDiff = request => dispatch => {
  getEvaluationDiffApi(request)
  .then(response => {
    if (response.message) {
      dispatch({ type: GET_EVALUATION_DIFF_FAIL, payload: { message: response.message, code: response.messageCode } });
    }
    dispatch({
      type: GET_EVALUATION_DIFF_SUCCESS, 
      payload: { 
        evaluationDiffList: response.evaluationDiffList, 
        gradeRange: response.gradeRange
      }
    });
  })
  .catch(error => {
    dispatch({ type: GET_EVALUATION_DIFF_FAIL, payload: { error: error } });
  });
}
